module.exports = __webpack_public_path__ + "img/seller_posting archives.e0706bc2.svg";